import urls from '../constants/urls'

export const LOAD_WHITELISTED_DOMAIN_FAILED = 'whitelistedDomain/LOAD_FAILED'
export const LOAD_WHITELISTED_DOMAIN_SUCCESS = 'whitelistedDomain/LOAD_SUCCESS'
export const LOADING_WHITELISTED_DOMAIN = 'whitelistedDomain/LOADING'

export const LOAD_WHITELISTED_DOMAIN_USERS_FAILED = 'whitelistedDomain/LOAD_USERS_FAILED'
export const LOAD_WHITELISTED_DOMAIN_USERS_SUCCESS = 'whitelistedDomain/LOAD_USERS_SUCCESS'
export const LOADING_WHITELISTED_DOMAIN_USERS = 'whitelistedDomain/LOADING_USERS'

const initialState = {
  domain: {},
  users:  [],

  pages: 1,
  page:  1,
  total: 0,

  failedLoading:      false,
  failedLoadingUsers: false,

  hasLoaded:      false,
  hasLoadedUsers: false,

  isLoading:      false,
  isLoadingUsers: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WHITELISTED_DOMAIN:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case LOAD_WHITELISTED_DOMAIN_SUCCESS:
      return {
        ...state,
        domain: action.payload.data
      }

    case LOAD_WHITELISTED_DOMAIN_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    case LOADING_WHITELISTED_DOMAIN_USERS:
      return {
        ...state,
        isLoadingUsers:     true,
        failedLoadingUsers: false
      }

    case LOAD_WHITELISTED_DOMAIN_USERS_SUCCESS:
      return {
        ...state,
        users:              action.payload.data,
        total:              action.payload.headers['x-total'],
        pages:              action.payload.headers['x-pages'],
        page:               action.payload.headers['x-page'],
        isLoadingUsers:     false,
        failedLoadingUsers: false,
        hasLoadedUsers:     true
      }

    case LOAD_WHITELISTED_DOMAIN_USERS_FAILED:
      return {
        ...state,
        isLoadingUsers:     false,
        failedLoadingUsers: true
      }

    default:
      return state
  }
}

export const loadDomain = (hospitalId, domainId) => (dispatch) => {
  return dispatch({
    types: [
      LOADING_WHITELISTED_DOMAIN,
      LOAD_WHITELISTED_DOMAIN_SUCCESS,
      LOAD_WHITELISTED_DOMAIN_FAILED
    ],
    payload: {
      request: {
        url: urls.hospitals.whitelistedDomains.show(hospitalId, domainId)
      }
    }
  })
}

export const loadUsers = (hospitalId, domainId, page) => (dispatch) => {
  return dispatch({
    types: [
      LOADING_WHITELISTED_DOMAIN_USERS,
      LOAD_WHITELISTED_DOMAIN_USERS_SUCCESS,
      LOAD_WHITELISTED_DOMAIN_USERS_FAILED
    ],
    payload: {
      request: {
        url:    urls.hospitals.whitelistedDomains.users.show(hospitalId, domainId),
        params: { page }
      }
    }
  })
}
